// ===== Toast global (notificaciones bonitas de stock/carrito) =====
function owToast(msg,kind){
  var t=document.getElementById('ow-toast');
  if(!t){ t=document.createElement('div'); t.id='ow-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); document.body.appendChild(t); }
  t.className='ow-toast'+(kind?' ow-toast--'+kind:'');
  t.innerHTML='<span class="ow-toast__dot"></span><span>'+msg+'</span>';
  void t.offsetWidth;
  t.classList.add('show');
  clearTimeout(t._t); t._t=setTimeout(function(){t.classList.remove('show');},4200);
}

// ---- product data (real Oromo catalogue) ----
var PRODUCTS=[
 {c:"Guatemala",lot:"Qawale",oc:"--o-guatemala",img:"elixir-volcanico",perfil:"espresso",
  spec:{"Región":"Huehuetenango","Origen":"Guatemala","Finca":"La Bolsa","Altura":"1.600 msnm","Variedad":"Bourbon · Caturra","Proceso":"Lavado"},
  notas:["Chocolate","Panela","Manzanas rojas"],price:"13.600"},
 {c:"Kenia",lot:"Nyeri AB",oc:"--o-kenia",img:"kenyanyeriab",perfil:"filtrado",
  spec:{"Región":"Nyeri","Origen":"Kenia","Finca":"New Gikaru","Altura":"1.630 msnm","Variedad":"SL28 · SL34","Proceso":"Doble ferment."},
  notas:["Naranja","Damasco","Albaricoque"],price:"13.700"},
 {c:"Honduras",lot:"La Valentina",oc:"--o-valentina",img:"honduras-la-valentina",perfil:"filtrado",
  spec:{"Región":"La Paz","Origen":"Honduras","Finca":"La Valentina","Altura":"1.650 msnm","Variedad":"Catuaí Amarillo","Proceso":"Anaeróbico"},
  notas:["Frutos rojos","Panela","Caramelo","Cítrico"],price:"17.700"},
 {c:"Ruanda",lot:"Espresso Essence",oc:"--o-ruanda",img:"ruanda-espresso-essence",perfil:"espresso",
  spec:{"Región":"Ngororero","Origen":"Ruanda","Finca":"Prov. Occidental","Altura":"1.616 msnm","Variedad":"Bourbon","Proceso":"Full lavado"},
  notas:["Vainilla","Piña","Nuez"],price:"13.700"},
 {c:"Indonesia",lot:"Bies Awan",oc:"--o-indonesia",img:"biesawansumatra",perfil:"filtrado",
  spec:{"Región":"Gayo, Aceh","Origen":"Indonesia","Finca":"Keti Ara","Altura":"1.400 msnm","Variedad":"Híbrido Timor","Proceso":"Trillado húm."},
  notas:["Melón","Chocolate","Nuez moscada","Cedro"],price:"14.700"},
 {c:"Honduras",lot:"El Jardín",oc:"--o-eljardin",img:"honduras-el-jardin",perfil:"espresso",
  spec:{"Región":"La Paz","Origen":"Honduras","Finca":"El Jardín","Altura":"1.650 msnm","Variedad":"Catuaí","Proceso":"Natural"},
  notas:["Chocolate","Frutos rojos","Cacao","Miel"],price:"17.300"},
 {c:"Perú",lot:"Alturas de Cajamarca",oc:"--o-peru",img:"peru-alturas-de-cajamarca",perfil:"filtrado",
  spec:{"Región":"Cajamarca","Origen":"Perú","Finca":"La Buena Amante","Altura":"1.760 msnm","Variedad":"Catimor","Proceso":"Lavado"},
  notas:["Chocolate","Cereales","Avellana"],price:"13.000",was:"13.500"},
 {c:"Bolivia",lot:"Kukucha Yungas",oc:"--o-bolivia",img:"kukucha-yungas-bolivia",perfil:"espresso",
  spec:{"Región":"Yungas","Origen":"Bolivia","Finca":"Alejandrina","Altura":"1.700 msnm","Variedad":"Catuaí Rojo","Proceso":"Lavado"},
  notas:["Nueces","Chocolate","Uvas"],price:"10.800"}
];
var EMBLEM='<svg class="emblem" viewBox="0 0 64 64"><circle cx="32" cy="32" r="24"/><line x1="18" y1="46" x2="46" y2="18"/></svg>';
function card(p){
  var spec="";for(var k in p.spec){spec+='<div><dt>'+k+'</dt><dd>'+p.spec[k]+'</dd></div>';}
  var chips=p.notas.map(function(n){return '<span>'+n+'</span>';}).join('');
  var price=(p.was?'<s>$'+p.was+'</s>':'')+'$'+p.price;
  return '<article class="pcard" data-perfil="'+p.perfil+'" style="--oc:var('+p.oc+')">'
   +'<div class="pcard-top"><div><div class="country">'+p.c+'</div><div class="lot">'+p.lot+'</div></div>'+EMBLEM+'</div>'
   +'<div class="pcard-media"><img src="assets/products/'+p.img+'.png" alt="'+p.c+' '+p.lot+'" loading="lazy"></div>'
   +'<div class="pcard-body"><dl class="spec">'+spec+'</dl>'
   +'<div class="notas"><span class="lbl">Notas de cata</span><div class="chips">'+chips+'</div></div>'
   +'<div class="pcard-foot"><div class="price">'+price+'<div class="tag">'+p.perfil+'</div></div>'
   +'<button class="add">Agregar</button></div></div></article>';
}
// Catálogo: ahora se renderiza server-side en Liquid (snippet ow-pcard) con imagen y precio reales.
// El generador JS anterior quedó desactivado para no sobreescribir la grilla real.
// ===== Filtros facetados del catálogo (perfil · origen · tueste · notas) =====
(function(){
  var bar=document.querySelector('[data-filters-bar]'); if(!bar)return;
  var grid=document.getElementById('pgrid'); if(!grid)return;
  var wrapEl=bar.parentNode, active={};
  function apply(){
    var tokens=[]; for(var g in active){ if(active[g])tokens.push(active[g]); }
    var shown=0;
    grid.querySelectorAll('.pcard').forEach(function(card){
      var f=(card.getAttribute('data-filters')||'').split(/\s+/);
      var ok=tokens.every(function(t){return f.indexOf(t)>-1;});
      card.style.display=ok?'':'none'; if(ok)shown++;
    });
    var empty=wrapEl.querySelector('[data-filters-empty]'); if(empty)empty.hidden=(shown>0);
  }
  function reset(){
    active={};
    bar.querySelectorAll('.cat-fgroup').forEach(function(gr){
      gr.querySelectorAll('.cat-fchip').forEach(function(c,i){c.classList.toggle('on',i===0);});
    });
    apply();
  }
  bar.addEventListener('click',function(e){
    var chip=e.target.closest('.cat-fchip'); if(!chip)return;
    var grp=chip.closest('.cat-fgroup'), group=grp.getAttribute('data-group'), val=chip.getAttribute('data-filter');
    active[group]=val;
    grp.querySelectorAll('.cat-fchip').forEach(function(c){c.classList.toggle('on',c===chip);});
    apply();
  });
  document.querySelectorAll('[data-filters-reset]').forEach(function(b){b.addEventListener('click',reset);});
})();
// nav scroll
var nav=document.getElementById('nav');
addEventListener('scroll',function(){nav.classList.toggle('scrolled',scrollY>60)});
(function(){
  var burger=document.getElementById('burger'),menu=document.getElementById('mobileMenu');
  var navEl=document.getElementById('nav');
  function toggle(open){var o=(open!==undefined)?open:!menu.classList.contains('open');menu.classList.toggle('open',o);burger.classList.toggle('open',o);navEl.classList.toggle('menu-open',o);burger.setAttribute('aria-expanded',o);}
  burger.addEventListener('click',function(){toggle();});
  menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){toggle(false);});});
})();
// hero video: lighter file on mobile, respect reduced motion
(function(){
  var v=document.getElementById('herovid');
  if(!v)return;
  if(matchMedia('(prefers-reduced-motion:reduce)').matches){v.removeAttribute('autoplay');try{v.pause();}catch(e){}return;}
  v.muted=true; v.play&&v.play().catch(function(){});
})();
// respect reduced motion for the secondary autoplay video
if(matchMedia('(prefers-reduced-motion:reduce)').matches){
  document.querySelectorAll('video.soft-vid').forEach(function(v){v.removeAttribute('autoplay');try{v.pause();}catch(e){}});
}
// reveal on scroll
// threshold 0: un umbral por porcentaje nunca se cumple en secciones más altas que la pantalla
// (la de reseñas quedaba invisible). El rootMargin negativo conserva el efecto de entrada.
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{threshold:0,rootMargin:'0px 0px -8% 0px'});
document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
// Ficha de origen: toggle por tap (móvil) en tarjetas de catálogo/colección (.pcard--ficha)
document.addEventListener('click',function(e){
  var dt=e.target.closest('[data-detail-toggle]');
  if(dt){var c=dt.closest('.pcard--ficha');if(c){c.classList.toggle('show-detail');return;}}
  var od=e.target.closest('.pcard-detail');
  if(od){var c2=od.closest('.pcard--ficha');if(c2)c2.classList.remove('show-detail');}
});
// count up
var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var el=e.target,t=parseFloat(el.dataset.count),su=el.dataset.suf||'',pr=el.dataset.pre||'',s=null;
  function fmt(n){return n.toLocaleString('es-CL');}
  function st(ts){if(!s)s=ts;var p=Math.min((ts-s)/1400,1);el.textContent=pr+fmt(Math.round(t*(1-Math.pow(1-p,3))))+su;if(p<1)requestAnimationFrame(st);else el.textContent=pr+fmt(t)+su;}
  requestAnimationFrame(st);cio.unobserve(el);})},{threshold:.6});
document.querySelectorAll('.count[data-count]').forEach(function(el){cio.observe(el)});

// ===== Coffee Box builder (6 slots · 10% al 4° · 20% al 6°) =====
(function(){
  var root=document.querySelector('[data-box]'); if(!root)return;
  var MAX=parseInt(root.dataset.max,10)||6;
  var T1=parseInt(root.dataset.tier1,10),D1=parseInt(root.dataset.disc1,10),C1=root.dataset.code1;
  var T2=parseInt(root.dataset.tier2,10),D2=parseInt(root.dataset.disc2,10),C2=root.dataset.code2;
  var slotsEl=root.querySelector('[data-box-slots]'), slots=[];
  var sticky=root.querySelector('[data-box-sticky]'), mainBar=root.querySelector('[data-box-bar]'), navEl=document.querySelector('.nav'), syncQ=false;
  function doSync(){
    syncQ=false;
    if(!sticky)return;
    sticky.classList.toggle('show', slots.length>0); // barra anclada: visible en todo momento con ≥1 café
  }
  function syncSticky(){ if(syncQ)return; syncQ=true; requestAnimationFrame(doSync); }
  window.addEventListener('scroll',syncSticky,{passive:true});
  window.addEventListener('resize',syncSticky);
  function money(c){c=parseInt(c,10);if(isNaN(c))c=0;return '$'+(c/100).toLocaleString('es-CL');}
  function amtFor(n){ if(n>=T2)return D2*100; if(n>=T1)return D1*100; return 0; } // monto fijo en centavos
  function render(){
    slotsEl.querySelectorAll('.box-slot').forEach(function(cell,i){
      var s=slots[i];
      if(s){ cell.classList.add('filled'); cell.style.setProperty('--oc','var(--'+s.oc+')');
        cell.innerHTML='<button class="box-slot-x" type="button" data-slot-remove="'+i+'" aria-label="Quitar">&times;</button><span class="box-slot-name">'+s.name+'</span><span class="box-slot-mol">En grano</span>'; }
      else { cell.classList.remove('filled'); cell.style.removeProperty('--oc'); cell.innerHTML='<span class="box-slot-n">'+(i+1)+'</span>'; }
    });
    var n=slots.length, sub=slots.reduce(function(a,s){return a+s.price;},0), disc=amtFor(n);
    if(disc>sub)disc=sub; var total=sub-disc;
    root.querySelector('[data-box-count]').textContent=n+' / '+MAX;
    root.querySelector('[data-box-subtotal]').textContent=money(sub);
    var dl=root.querySelector('[data-box-disc-line]');
    if(disc>0){dl.hidden=false;root.querySelector('[data-box-disc-label]').textContent='Descuento';root.querySelector('[data-box-disc]').textContent='– '+money(disc);}
    else dl.hidden=true;
    root.querySelector('[data-box-total]').textContent=money(total);
    root.querySelectorAll('[data-box-continue]').forEach(function(b){b.disabled=(n===0);});
    var hint=root.querySelector('[data-box-hint]'), noDisc=(D1===0&&D2===0);
    if(n===0)hint.textContent='Agrega cafés para armar tu box.';
    else if(noDisc)hint.textContent=(n>=MAX?'Box completo. Listo para continuar.':'Puedes agregar '+(MAX-n)+' café'+((MAX-n)===1?'':'s')+' más.');
    else if(n<T1)hint.textContent='Agrega '+(T1-n)+' más y ahorra '+money(D1*100)+'.';
    else if(n<T2)hint.textContent='Agrega '+(T2-n)+' más y ahorra '+money(D2*100)+'.';
    else hint.textContent='Ahorro máximo aplicado: '+money(D2*100)+'.';
    root.querySelectorAll('[data-box-add]').forEach(function(b){ if(!b.hasAttribute('data-sold')) b.disabled=(n>=MAX); });
    // Barra de progreso del descuento (visual, en vivo)
    var fill=root.querySelector('[data-box-prog-fill]');
    if(fill)fill.style.width=((n>MAX?MAX:n)/MAX*100)+'%';
    var unlockedPct=null;
    root.querySelectorAll('.box-prog-mile').forEach(function(mile){
      var q=parseInt(mile.dataset.mile,10),hit=n>=q;
      if(hit&&!mile.classList.contains('reached')){
        mile.classList.add('reached','just-unlocked');
        var tag=mile.querySelector('.box-prog-tag'); unlockedPct=tag?tag.textContent:null;
        setTimeout(function(){mile.classList.remove('just-unlocked');},700);
      } else if(!hit){ mile.classList.remove('reached'); }
    });
    var st=root.querySelector('[data-box-prog-status]');
    if(st){
      if(unlockedPct)st.textContent='¡'+unlockedPct+' desbloqueado!';
      else if(n===0)st.textContent='Agrega cafés y ahorra';
      else if(n<T1)st.textContent='Te faltan '+(T1-n)+' para ahorrar '+money(D1*100);
      else if(n<T2)st.textContent='Te faltan '+(T2-n)+' para ahorrar '+money(D2*100);
      else st.textContent='Ahorro máximo: '+money(D2*100);
    }
    root.querySelectorAll('[data-tierchip]').forEach(function(chip){
      chip.classList.toggle('reached',n>=parseInt(chip.dataset.tierchip,10));
    });
    // Barra anclada: miniaturas (foto+precio+nombre), slots vacíos, meta de descuento, total tachado + ahorro
    if(sticky){
      var goalAmt=0, need=0;
      if(n<T1){goalAmt=D1*100;need=T1-n;} else if(n<T2){goalAmt=D2*100;need=T2-n;}
      var ss=sticky.querySelector('[data-s-slots]');
      if(ss){ var h='';
        for(var i=0;i<MAX;i++){ var sl=slots[i];
          if(sl){ h+='<span class="box-sticky-thumb" style="--oc:var(--'+sl.oc+')" title="'+sl.name+'"><button class="box-sticky-x" type="button" data-slot-remove="'+i+'" aria-label="Quitar">&times;</button>'+(sl.image?'<img src="'+sl.image+'" alt="">':'<span class="box-sticky-imgph"></span>')+'<span class="box-sticky-cap"><b>'+money(sl.price)+'</b>'+(sl.name||'').split('·')[0].trim()+'</span></span>'; }
          else if(D1>0 && (i+1)===T1){ h+='<span class="box-sticky-goal" title="Descuento al '+T1+'° café">–'+money(D1*100)+'</span>'; }
          else if(D2>0 && (i+1)===T2){ h+='<span class="box-sticky-goal" title="Descuento al '+T2+'° café">–'+money(D2*100)+'</span>'; }
          else { h+='<span class="box-sticky-thumb box-sticky-thumb--empty">+</span>'; }
        }
        ss.innerHTML=h;
      }
      var stot=sticky.querySelector('[data-s-total]'); if(stot)stot.textContent=money(total);
      var sorig=sticky.querySelector('[data-s-orig]'); if(sorig){ sorig.hidden=(disc<=0); sorig.textContent=money(sub); }
      var ssave=sticky.querySelector('[data-s-save]'); if(ssave){ ssave.hidden=(disc<=0); ssave.textContent='Ahorras '+money(disc); }
      var sst=sticky.querySelector('[data-s-status]');
      if(sst){ if(n===0)sst.textContent='Agrega cafés para armar tu box'; else if(D1===0&&D2===0)sst.textContent=(n>=MAX?'Box completo · listo para pagar':'Puedes agregar '+(MAX-n)+' café'+((MAX-n)===1?'':'s')+' más'); else if(goalAmt>0)sst.textContent='Añade '+need+' producto'+(need>1?'s':'')+' más para ahorrar '+money(goalAmt); else sst.textContent='Ahorro máximo aplicado: '+money(disc); }
    }
    syncSticky();
  }
  root.addEventListener('click',function(e){
    var dt=e.target.closest('[data-detail-toggle]');
    if(dt){ var dc=dt.closest('.boxcard'); if(dc)dc.classList.toggle('show-detail'); return; }
    var od=e.target.closest('.pcard-detail');
    if(od){ var oc2=od.closest('.boxcard'); if(oc2)oc2.classList.remove('show-detail'); return; }
    var add=e.target.closest('[data-box-add]');
    if(add && !add.disabled){
      if(slots.length>=MAX)return;
      var card=add.closest('.boxcard');
      slots.push({variant:card.dataset.variant,name:card.dataset.name,price:parseInt(card.dataset.price,10),image:card.dataset.image,oc:card.dataset.oc||'clay'});
      card.classList.add('just-added'); setTimeout(function(){card.classList.remove('just-added');},600);
      render(); return;
    }
    var rm=e.target.closest('[data-slot-remove]');
    if(rm){ slots.splice(parseInt(rm.dataset.slotRemove,10),1); render(); }
  });
  root.querySelectorAll('[data-box-continue]').forEach(function(cbtn){ cbtn.addEventListener('click',function(){
    if(!slots.length)return;
    var btn=this; root.querySelectorAll('[data-box-continue]').forEach(function(b){b.disabled=true;}); btn.textContent='Preparando tu box…';
    var items=slots.map(function(s){return {id:parseInt(s.variant,10),quantity:1,properties:{'Coffee Box':'Sí'}};});
    // Vaciar el carrito primero: el box va solo a checkout, sin arrastrar ítems previos.
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});})
      .then(function(r){ if(!r.ok){ return r.json().then(function(d){throw d;}); } return r.json(); })
      .then(function(){
        var nn=slots.length, code=nn>=T2?C2:(nn>=T1?C1:'');
        // Ruta oficial de Shopify para aplicar código: /discount/CODIGO?redirect=
        // El preview local del CLI no soporta /discount/ (401), ahí se va directo a checkout sin código.
        var esPreviewLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
        window.location.href = (code && !esPreviewLocal) ? '/discount/'+encodeURIComponent(code)+'?redirect=/checkout' : '/checkout';
      })
      .catch(function(err){ root.querySelectorAll('[data-box-continue]').forEach(function(b){b.disabled=false;}); btn.textContent='Continuar';
        owToast((err&&err.description) ? err.description : 'Uno de los cafés se agotó mientras armabas el box. Ajusta tu selección.','warn'); });
  }); });
  render();
})();

// ===== Coffee Box · presets de un clic =====
// Llenan los cupos disparando los MISMOS clicks del armador: respetan agotados, tope de
// slots y molienda por defecto. Perfil se compara en minúsculas (el metafield puede venir
// capitalizado desde el admin). Si un perfil no alcanza el objetivo, completa con el resto
// del catálogo sin repetir cafés; si aun así no llega, se queda corto y no promete descuento.
(function(){
  var root=document.querySelector('[data-box]'); if(!root)return;
  var wrap=root.querySelector('[data-box-presets]'); if(!wrap)return;
  function filled(){ return root.querySelectorAll('.box-slot.filled').length; }
  function clearAll(){ var x,guard=0; while((x=root.querySelector('[data-slot-remove]'))&&guard++<40){ x.click(); } }
  function tryAdd(card){
    var b=card.querySelector('[data-box-add]');
    if(!b||b.disabled||b.hasAttribute('data-sold'))return;
    b.click();
  }
  wrap.addEventListener('click',function(e){
    var btn=e.target.closest('[data-box-preset]'); if(!btn)return;
    var kind=btn.getAttribute('data-box-preset');
    var n=parseInt(btn.getAttribute('data-n'),10)||4;
    clearAll();
    var all=Array.prototype.slice.call(root.querySelectorAll('.boxcard'));
    var match=(kind==='all')?all.slice():all.filter(function(c){
      return (c.getAttribute('data-perfil')||'').toLowerCase().indexOf(kind)>-1;
    });
    var queue=match.concat(all.filter(function(c){return match.indexOf(c)<0;}));
    queue.some(function(c){ if(filled()>=n)return true; tryAdd(c); return filled()>=n; });
    wrap.querySelectorAll('.box-preset').forEach(function(b){b.classList.toggle('on',b===btn);});
    var bar=root.querySelector('[data-box-bar]');
    if(bar)bar.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
  });
})();

// ===== Catálogo: precio por Formato + Carrito lateral (drawer) =====
(function(){
  var drawer=document.querySelector('[data-cart-drawer]'),
      ov=document.querySelector('[data-cart-ov]'),
      itemsEl=document.querySelector('[data-cart-items]'),
      footEl=document.querySelector('[data-cart-footer]'),
      subEl=document.querySelector('[data-cart-subtotal]');
  var maxedKeys={};
  function findLine(cart,key){for(var i=0;i<cart.items.length;i++){if(cart.items[i].key===key)return cart.items[i];}return null;}

  function money(c){c=parseInt(c,10);if(isNaN(c))c=0;return '$'+(c/100).toLocaleString('es-CL');}
  function setCount(n){n=parseInt(n,10);if(isNaN(n))n=0;document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;if(n>0){el.removeAttribute('data-empty');}else{el.setAttribute('data-empty','');}});}
  function openCart(){if(!drawer)return;drawer.classList.add('open');ov.classList.add('open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function closeCart(){if(!drawer)return;drawer.classList.remove('open');ov.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}

  function lineHTML(it){
    var props='';
    if(it.properties){for(var k in it.properties){if(k.charAt(0)!=='_'&&it.properties[k]){props+='<span class="ow-ci__prop">'+k+': '+it.properties[k]+'</span>';}}}
    var img=it.image?'<img src="'+it.image+'" alt="" loading="lazy">':'';
    var maxed=maxedKeys[it.key];
    return '<div class="ow-ci'+(maxed?' ow-ci--max':'')+'" data-key="'+it.key+'">'
      +'<div class="ow-ci__img">'+img+'</div>'
      +'<div class="ow-ci__b">'
        +'<div class="ow-ci__t">'+it.product_title+'</div>'
        +'<div class="ow-ci__m">'+(it.variant_title||'')+'</div>'+props
        +'<div class="ow-ci__r">'
          +'<div class="ow-qty"><button type="button" data-dec aria-label="Menos">&minus;</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Más"'+(maxed?' disabled':'')+'>+</button></div>'
          +'<span class="ow-ci__p">'+money(it.final_line_price)+'</span>'
        +'</div>'
        +(maxed?'<div class="ow-ci__max">Máximo en stock disponible</div>':'')
        +'<button type="button" class="ow-ci__rm" data-rm>Quitar</button>'
      +'</div></div>';
  }
  function render(cart){
    if(!cart||!cart.items)return;
    setCount(cart.item_count);
    if(subEl)subEl.textContent=money(cart.total_price);
    if(footEl)footEl.hidden=(cart.item_count===0);
    // Barra de envío gratis
    var free=drawer?parseInt(drawer.getAttribute('data-free-ship'),10):0;
    var shipEl=drawer?drawer.querySelector('[data-ship]'):null;
    if(shipEl&&free>0){
      if(cart.item_count>0){
        shipEl.hidden=false;
        var rem=free-cart.total_price, pct=Math.min(cart.total_price/free*100,100);
        shipEl.querySelector('[data-ship-fill]').style.width=pct+'%';
        var msg=shipEl.querySelector('[data-ship-msg]');
        if(rem>0){ shipEl.classList.remove('done'); msg.innerHTML='Te faltan <b>'+money(rem)+'</b> para el envío gratis en RM'; }
        else { shipEl.classList.add('done'); msg.innerHTML='Tienes <b>envío gratis en RM</b>.'; }
      } else { shipEl.hidden=true; }
    }
    if(!itemsEl)return;
    itemsEl.innerHTML=cart.items.length?cart.items.map(lineHTML).join(''):'<p class="ow-cart__empty">Tu carrito está vacío.</p>';
  }
  function refresh(doOpen){return fetch('/cart.js?t='+Date.now(),{cache:'no-store',headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);if(doOpen)openCart();return c;});}
  function change(key,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){ if(c&&c.items){render(c);return c;} return refresh(false); });}

  if(ov)ov.addEventListener('click',closeCart);
  document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});
  document.querySelectorAll('[data-cart-link]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();refresh(true);});});
  document.querySelectorAll('[data-cart-clear]').forEach(function(b){b.addEventListener('click',function(){
    b.disabled=true; maxedKeys={};
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){return refresh(false);})
      .then(function(){owToast('Carrito vaciado.');})
      .catch(function(){})
      .finally(function(){b.disabled=false;});
  });});
  if(itemsEl)itemsEl.addEventListener('click',function(e){
    var ci=e.target.closest('.ow-ci');if(!ci)return;
    var key=ci.getAttribute('data-key'),q=parseInt(ci.querySelector('.ow-qty span').textContent,10);
    if(e.target.closest('[data-rm]')){ delete maxedKeys[key]; change(key,0); }
    else if(e.target.closest('[data-inc]')){
      change(key,q+1).then(function(c){
        if(!c||!c.items)return;
        var line=findLine(c,key);
        if(!line || line.quantity<=q){ maxedKeys[key]=true; owToast('Llegaste al máximo disponible de este café.','warn'); render(c); }
        else if(maxedKeys[key]){ delete maxedKeys[key]; }
      });
    }
    else if(e.target.closest('[data-dec]')){ delete maxedKeys[key]; change(key,q-1); }
  });

  // precio + oferta según el formato elegido
  document.querySelectorAll('[data-formato]').forEach(function(sel){
    sel.addEventListener('change',function(){
      var opt=sel.selectedOptions[0];
      // En la PDP el precio vive fuera del <form>, por eso se busca primero el panel completo.
      var form=sel.closest('.pdp-buy')||sel.closest('.pcard-buy');if(!form)return;
      var ce=form.querySelector('[data-price-compare]'),fe=form.querySelector('[data-fmt-out]');
      form.querySelectorAll('[data-price-out]').forEach(function(pe){pe.textContent=opt.getAttribute('data-price')||'';});
      if(ce)ce.textContent=opt.getAttribute('data-compare')||'';
      if(fe)fe.textContent=opt.getAttribute('data-fmt')||'';
    });
  });
  // PDP: botones de formato que manejan el <select> real (mantiene precio y add-to-cart intactos)
  document.querySelectorAll('.pdp-fmt').forEach(function(root){
    var sel=root.querySelector('[data-formato]');if(!sel)return;
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-fmt-btn]');if(!b||b.disabled)return;
      sel.value=b.getAttribute('data-fmt-btn');
      sel.dispatchEvent(new Event('change',{bubbles:true}));
      root.querySelectorAll('[data-fmt-btn]').forEach(function(x){x.classList.toggle('on',x===b);});
    });
  });
  // Agregar -> add al carrito + abrir drawer (fallback POST si falla)
  document.querySelectorAll('form.pcard-buy').forEach(function(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('.add'),fmt=form.querySelector('[data-formato]'),mol=form.querySelector('[data-molienda]');
      if(!fmt)return form.submit();
      btn.classList.add('is-loading');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:parseInt(fmt.value,10),quantity:1,properties:mol?{'Molienda':mol.value}:{}}]})})
        .then(function(r){ if(!r.ok){ return r.json().then(function(d){throw d;}); } return r.json(); })
        .then(function(added){owTrackAdd(added);return refresh(true);})
        .catch(function(err){ if(err&&err.description){ owToast(err.description,'warn'); } else { form.submit(); } })
        .finally(function(){btn.classList.remove('is-loading');});
    });
  });
})();

// ===== PDP: pestañas de guía + galería =====
(function(){
  document.querySelectorAll('[data-tabs]').forEach(function(root){
    var tabs=root.querySelectorAll('.pdp-tab'), panels=root.querySelectorAll('.pdp-panel');
    root.addEventListener('click',function(e){
      var t=e.target.closest('.pdp-tab'); if(!t)return;
      var i=t.dataset.tab;
      tabs.forEach(function(x){x.classList.toggle('on',x===t);});
      panels.forEach(function(p){p.classList.toggle('on',p.dataset.panel===i);});
    });
  });
  var g=document.querySelector('[data-gallery]');
  if(g){
    var main=g.querySelector('[data-gallery-main]');
    // Precarga: sin esto cada clic dispara la descarga de la imagen grande y se siente lento.
    var thumbs=g.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function(t){var pre=new Image();pre.decoding='async';pre.src=t.dataset.galleryThumb;});
    g.addEventListener('click',function(e){
      var th=e.target.closest('[data-gallery-thumb]'); if(!th||!main)return;
      var src=th.dataset.galleryThumb;
      if(main.getAttribute('src')===src)return;
      main.classList.add('is-swapping');
      var img=new Image();
      img.onload=img.onerror=function(){main.src=src;main.classList.remove('is-swapping');};
      img.src=src;
      g.querySelectorAll('.pdp-thumb').forEach(function(x){x.classList.toggle('on',x===th);});
    });
  }
})();

// ===== Rueda de sabores · lightbox + zoom al clic =====
(function(){
  var openBtn=document.querySelector('[data-rueda-zoom]'), lb=document.querySelector('[data-rueda-lb]');
  if(!openBtn||!lb)return;
  var img=lb.querySelector('[data-rueda-img]'), closeBtn=lb.querySelector('[data-rueda-close]');
  function show(){lb.hidden=false;void lb.offsetWidth;lb.classList.add('open');document.body.style.overflow='hidden';}
  function hide(){lb.classList.remove('open');img.classList.remove('zoomed');img.style.transformOrigin='center';document.body.style.overflow='';setTimeout(function(){lb.hidden=true;},300);}
  openBtn.addEventListener('click',show);
  closeBtn.addEventListener('click',hide);
  lb.addEventListener('click',function(e){ if(e.target===lb)hide(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!lb.hidden)hide(); });
  img.addEventListener('click',function(e){ e.stopPropagation(); img.classList.toggle('zoomed'); });
  img.addEventListener('mousemove',function(e){
    if(!img.classList.contains('zoomed'))return;
    var r=img.getBoundingClientRect();
    img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
  });
})();

// ===== Tracking e-commerce: Klaviyo onsite + dataLayer (Meta/GA vía canales de venta) =====
function owTrackAdd(added){
  try{
    var it = added && (added.items ? added.items[0] : added);
    if(!it) return;
    var price = (it.final_price || it.price || 0)/100;
    (window.klaviyo=window.klaviyo||[]).push(['track','Added to Cart',{
      '$value': price,
      AddedItemProductName: it.product_title || it.title,
      AddedItemProductID: it.product_id,
      AddedItemVariantID: it.variant_id || it.id,
      AddedItemQuantity: it.quantity || 1,
      AddedItemURL: it.url ? (location.origin + it.url) : location.href
    }]);
    (window.dataLayer=window.dataLayer||[]).push({
      event:'add_to_cart',
      ecommerce:{ currency:'CLP', value:price, items:[{
        item_id: it.product_id, item_name: it.product_title || it.title, price: price, quantity: it.quantity || 1
      }]}
    });
    document.dispatchEvent(new CustomEvent('ow:add-to-cart',{detail:it}));
  }catch(e){}
}

// Suscripción directa a Klaviyo desde el formulario nativo (diseño del tema intacto)
(function(){
  var COMPANY='WvAXCc';
  document.querySelectorAll('form.news[data-klaviyo-list]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var inp=f.querySelector('input[type=email]'), email=inp?inp.value.trim():'';
      if(!email)return;
      var list=f.getAttribute('data-klaviyo-list'), btn=f.querySelector('button[type=submit]');
      if(btn)btn.disabled=true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+COMPANY,{
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:list}}}}})
      }).then(function(r){
        if(r.ok||r.status===202){ f.innerHTML='<p class="news-ok">'+(f.getAttribute('data-ok')||'¡Listo!')+'</p>'; }
        else { if(btn)btn.disabled=false; if(window.owToast)owToast('No pudimos suscribirte, intenta de nuevo.','warn'); }
      }).catch(function(){ if(btn)btn.disabled=false; if(window.owToast)owToast('No pudimos suscribirte, intenta de nuevo.','warn'); });
    });
  });
})();
